export const NAME = 'navbar';


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/constants.js
 **/